module.exports = __webpack_public_path__ + "img/ic_medium.c5e0bcca.svg";